import { Stack, useTheme } from "@mui/material";
import { Questionnaire } from "./Questionnaire";
import { ScoresAndIndicators } from "./ScoresAndIndicators";
import { ActionPlan } from "./ActionPlan";
import { useCompanyOverviewContext } from "src/context/Company/Overview/useCompanyOverviewContext";
import { getSsqDisplayTitle } from "src/utils/ssqTitle";

type Props = unknown;
export const ManyScoresOverview = (_props: Props) => {
    const theme = useTheme();
    const { filteredOverview } = useCompanyOverviewContext();

    if (filteredOverview === null) {
        // Error state
        return null;
    }

    const isActionnable = filteredOverview.scores.some((score) => {
        return score.isActionPlanAvailable;
    });
    const doesDataExist = filteredOverview.actionPlan !== null;

    // It means we want to show the data REGARDLESS OF isActionnable if it existed from previously;
    const shouldShow = doesDataExist ? true : isActionnable;
    const currentValue =
        filteredOverview.scores.find((score) => score.id === filteredOverview.actionPlan?.score.id)?.value ?? null;
    return (
        <Stack gap={theme.spacing(4)}>
            <Questionnaire overview={filteredOverview.ssq} />
            <ScoresAndIndicators ssq={filteredOverview.ssq} scores={filteredOverview.scores} />
            {shouldShow && (
                <ActionPlan
                    actionPlan={filteredOverview.actionPlan}
                    currentValue={currentValue}
                    questionnaireName={getSsqDisplayTitle(filteredOverview.ssq)}
                />
            )}
        </Stack>
    );
};
